import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/AdminLayout';
import { Heart, Search, User, Calendar, Users, CheckCircle2, MoreHorizontal, Eye, Settings, Archive } from 'lucide-react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import api from '../../lib/api';
import { toast } from 'sonner';

const AdminWeddings = () => {
    const [weddings, setWeddings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchWeddings();
    }, []);

    const fetchWeddings = async () => {
        try {
            const response = await api.get('/admin/weddings');
            setWeddings(response.data);
        } catch (error) {
            toast.error('Error al cargar bodas');
        } finally {
            setLoading(false);
        }
    };

    const filteredWeddings = weddings.filter(w =>
        w.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        w.user_name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <AdminLayout>
            <div className="space-y-6">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div className="relative flex-1 max-w-md">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                        <input
                            type="text"
                            placeholder="Buscar por título o novios..."
                            className="pl-10 pr-4 py-2 w-full bg-white border border-slate-200 rounded-lg text-sm focus:ring-wedding-primary transition-all"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>

                <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
                    <Table>
                        <TableHeader className="bg-slate-50">
                            <TableRow>
                                <TableHead>Boda / Código</TableHead>
                                <TableHead>Novios</TableHead>
                                <TableHead>Fecha Evento</TableHead>
                                <TableHead>Estado</TableHead>
                                <TableHead>Invitados</TableHead>
                                <TableHead>Registro</TableHead>
                                <TableHead className="text-right">Acciones</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {loading ? (
                                [1, 2, 3, 4, 5].map(i => (
                                    <TableRow key={i}>
                                        <TableCell colSpan={7} className="h-16 animate-pulse bg-slate-50/50"></TableCell>
                                    </TableRow>
                                ))
                            ) : filteredWeddings.length > 0 ? (
                                filteredWeddings.map((w) => (
                                    <TableRow key={w.id} className="hover:bg-slate-50 transition-colors">
                                        <TableCell>
                                            <div className="flex flex-col">
                                                <span className="font-semibold text-slate-800">{w.title}</span>
                                                <span className="text-xs text-slate-500 font-mono">#{w.public_token?.slice(0, 8)}</span>
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className="flex items-center text-sm">
                                                <User className="h-3 w-3 mr-2 text-slate-400" />
                                                {w.user_name}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className="text-sm">
                                                <Calendar className="h-3 w-3 inline mr-2 text-slate-400" />
                                                {new Date(w.event_date).toLocaleDateString()}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            {new Date(w.event_date) > new Date() ? (
                                                <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200">Próxima</Badge>
                                            ) : (
                                                <Badge variant="outline" className="bg-slate-50 text-slate-700 border-slate-200">Pasada</Badge>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            <div className="flex items-center text-sm gap-3">
                                                <div className="flex items-center text-slate-500" title="Total Invitados">
                                                    <Users className="h-3 w-3 mr-1" /> {w.total_guests || 0}
                                                </div>
                                                <div className="flex items-center text-green-600" title="Familias Confirmadas">
                                                    <CheckCircle2 className="h-3 w-3 mr-1" /> {w.families_confirmed || 0}
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <span className="text-xs text-slate-400">{new Date(w.created_at).toLocaleDateString()}</span>
                                        </TableCell>
                                        <TableCell className="text-right">
                                            <div className="flex justify-end gap-1">
                                                <Button variant="ghost" size="icon" title="Ver Invitación">
                                                    <Eye className="h-4 w-4" />
                                                </Button>
                                                <Button variant="ghost" size="icon" title="Editar">
                                                    <Settings className="h-4 w-4" />
                                                </Button>
                                                <Button variant="ghost" size="icon" title="Archivar">
                                                    <Archive className="h-4 w-4" />
                                                </Button>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={7} className="h-32 text-center text-muted-foreground">
                                        No se encontraron bodas
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
            </div>
        </AdminLayout>
    );
};

export default AdminWeddings;
